import { useContext } from 'react';

import { EkycContext } from './ekyc-provider';
import { type EkycContextValue } from './types';

export default function useEkyc(): EkycContextValue {
  const context = useContext(EkycContext);
  if (context === undefined) {
    throw new Error('useEkyc must be used within an EkycProvider');
  }
  return context;
}

export { EkycContext, useEkyc };
